import { render, staticRenderFns } from "./accountsReceiveTotal.vue?vue&type=template&id=38fa3682&scoped=true&"
import script from "./accountsReceiveTotal.vue?vue&type=script&lang=js&"
export * from "./accountsReceiveTotal.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceiveTotal.vue?vue&type=style&index=0&id=38fa3682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa3682",
  null
  
)

export default component.exports